<template lang="pug">
ServicePopup.old-user-popup(@closePopup="closePopup")
  .old-user-popup__content
    h2.old-user-popup__title {{ $t(`popup_old_user.title`) }}
    .old-user-popup__text {{ $t(`popup_old_user.text`) }}

    button.button.button-medium-x15.old-user-popup__button(v-if="!is_tablet" @click="downloadGameCenter")
      span {{ $t(`popup_old_user.download`) }}

    button.button.button-medium-x15.old-user-popup__button(v-else @click="closePopup")
      span {{ $t(`popup_old_user.button`) }}

</template>

<script>
import { mapGetters } from "vuex";

import ServicePopup from "@static_promo_pages/common/components/service-popup/vue/ServicePopup";
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";

export default {
  name: "OldUserPopup",

  components: {
    ServicePopup,
  },

  mixins: [MobileDetection],

  computed: {
    ...mapGetters("global", ["isUserAuthedNotRegistered"]),
  },

  methods: {
    closePopup() {
      this.$emit("closePopup");
    },

    downloadGameCenter() {
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.$authService.downloadGameCenter();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/old-user-popup.scss";
</style>
